import { useAuth } from "@/context/auth";
import { TokenDTo } from "@/services/auth/type";
import { clubApi, silentErrors } from "@/services/axios";
import { Loader, Stack, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// One-time link from the landing after signup: exchanged for the same tokens as an OTP login.
export default function MagicLogin() {
  const [params] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = params.get("token");
    const fail = () => {
      notifications.show({ color: "orange", message: "لینک ورود منقضی شده؛ با شماره موبایل وارد شوید.", autoClose: 8000 });
      navigate("/auth/login", { replace: true });
    };
    if (!token) return fail();
    clubApi.instance
      .post<TokenDTo>("/api/auth/MagicLogin", { token }, silentErrors)
      .then(({ data }) => (data?.accessToken ? login(data, "/dashboard?welcome=1") : fail()))
      .catch(fail);
  }, [params, login, navigate]);

  return (
    <Stack align="center" justify="center" h="100svh" gap="md">
      <Loader color="violet" />
      <Text>در حال ورود به پنل…</Text>
    </Stack>
  );
}
